const PlayIcon = ({ width = "22px", fill }) => {
    return (
        <svg x="0px" y="0px" viewBox="0 0 25.2 25.2" xmlSpace="preserve" width={width} fill={fill}>
            <polygon points="4.2,1.1 22.7,12.6 4.2,24.2 " fill={fill}/>
        </svg>
    );
};

export default PlayIcon;